import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import Input from "rs-components/Input";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import SelectInput from "rs-components/Input/components/SelectInput";
import { FormField } from "../../index";
import { workspaceProcessDataSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
import { getAvailableFilteredProcessData } from "store/rs-workspace/utils/results.utils";
import * as styles from "../../styles.module.scss";
const ProcessDataSourceFormField = ({ sourcesForFilter }) => {
    const processData = useSelector(workspaceProcessDataSelector);
    const processDataOptions = useMemo(() => getAvailableFilteredProcessData(processData, sourcesForFilter?.map(({ processDataId }) => processDataId)).filteredProcessData.map(({ name, id }) => ({
        value: id,
        label: name,
    })), [processData, sourcesForFilter]);
    const noSources = useMemo(() => !processDataOptions.length, [processDataOptions.length]);
    return (React.createElement("div", { className: styles.processDataForm },
        React.createElement("div", { className: styles.field },
            React.createElement(Input, { itemRenderer: SelectItemRenderer, classes: {
                    component: classNames(styles.select, {
                        [styles.noSources]: noSources,
                    }),
                    label: styles["field-label"],
                }, component: SelectInput, name: FormField.processDataId, label: "Process Data", valueFormatter: ({ value }) => value, items: processDataOptions, placeholder: !processDataOptions.length ? "No Process Data to add." : "Select", restrictions: { IsMandatory: true } }))));
};
export default ProcessDataSourceFormField;
